// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Checkbox from "components/layout/Checkbox";
import Text from "components/typography/Text";
import VipStatus from "components/user/VipStatus";
import Tooltip from "components/layout/Tooltip";

// ** Utils & Helpers
import formatMessage from "utils/formatMessage";

// #####################################################

const VeryficationAndVip = ({ state, dispatch }) => {
	const { t } = useTranslation(["common", "userpanel"]);

	const user = useSelector((state) => state.globalUser);
	const preferences = useSelector(
		(state) => state.userpanelSettings?.preferences
	);

	// #####################################################

	return (
		<ul>
			<li key="verifyVipShowMyStatusLi">
				<Tooltip
					text={
						user?.status_vip < 3 &&
						t(
							"userpanel:settings.preferences.vip.tooltips.showMyStatus"
						)
					}
				>
					<Checkbox
						key="verifyVipShowMyStatus"
						checked={state.verifyVipShowMyStatus.status}
						onChange={() =>
							dispatch({
								type: "SET",
								field: "verifyVipShowMyStatus",
								special: true,
							})
						}
						showLabel
						noPaddingX
						renderLabel={() => (
							<Text ml={2}>
								{formatMessage(
									t(
										"userpanel:settings.preferences.vip.showMyStatus"
									),
									{
										status:
											user?.status_vip > 2 ? (
												<VipStatus
													status={user.status_vip}
													key="userpanel:payments.payments.supervip.desc1-1"
												/>
											) : (
												<>
													<VipStatus
														status={3}
														key="userpanel:payments.payments.supervip.desc1-1"
													/>
													<VipStatus
														status={5}
														key="userpanel:payments.payments.supervip.desc1-2"
													/>
												</>
											),
									}
								)}
							</Text>
						)}
						labelText={t(
							"userpanel:settings.preferences.vip.showMyStatus"
						)}
						disabled={!preferences?.verifyVipShowMyStatus?.enabled}
					/>
				</Tooltip>
			</li>
			<li key="verifyVipShowMyAgeLi">
				<Tooltip
					text={
						user?.status_vip < 5 &&
						t(
							"userpanel:settings.preferences.vip.tooltips.showMyAge"
						)
					}
				>
					<Checkbox
						key="verifyVipShowMyAge"
						checked={state.verifyVipShowMyAge.status}
						onChange={() =>
							dispatch({
								type: "SET",
								field: "verifyVipShowMyAge",
								special: true,
							})
						}
						showLabel
						noPaddingX
						labelText={t(
							"userpanel:settings.preferences.vip.showMyAge"
						)}
						disabled={!preferences?.verifyVipShowMyAge?.enabled}
					/>
				</Tooltip>
			</li>
			<li key="verifyVipRenewVipAutomaticallyLi">
				<Tooltip
					text={
						!preferences?.verifyVipRenewVipAutomatically?.enabled &&
						t("userpanel:settings.preferences.vip.tooltips.renew")
					}
				>
					<Checkbox
						key="verifyVipRenewVipAutomatically"
						checked={state.verifyVipRenewVipAutomatically.status}
						onChange={() =>
							dispatch({
								type: "SET",
								field: "verifyVipRenewVipAutomatically",
								special: true,
							})
						}
						showLabel
						noPaddingX
						labelText={t(
							"userpanel:settings.preferences.vip.renewVipAutomatically"
						)}
						disabled={
							!preferences?.verifyVipRenewVipAutomatically
								?.enabled
						}
					/>
				</Tooltip>
			</li>
		</ul>
	);
};

// #####################################################

export default VeryficationAndVip;

// #####################################################
